import { jobCreators } from '../behavior/jobCreators-sidecar'
import { jobs } from '../behavior/jobs-sidecar'
import { cargoes } from '../entities/cargoes-sidecar'
import { stacks } from '../entities/stacks-sidecar'
import { IMachine } from './machines'
import { machines } from './machines-sidecar'
import { IMachineType } from './machinesData'
import { spriteMap } from '../main/spriteMap-sidecar'
import { layers } from '../main/layers-sidecar'

const type: IMachineType = 'pile'

function ensure(obj: IMachine) {
  machines.ensureType(obj, type)
}

export function onCreate(obj: IMachine) {
  ensure(obj)
  obj.onUpdate = onUpdate

  let imageGhost = spriteMap.createImageFromFrameInfo(
    layers.getLayers().machines,
    obj.data.frames[0],
    0,
    0,
  )
  imageGhost.alpha = 0.75
  obj.imageGhost = imageGhost

  let jc = jobCreators.create(
    () => {
      if (obj.cargoes.length === obj.data.stackMaxSize) {
        return false
      }

      if (
        !cargoes.findClosestTo(
          obj.i,
          obj.j,
          (c) => c.data.type === obj.holdsType && !c.carriedBy && !c.inStack,
        )
      ) {
        return false
      }

      return true
    },
    () => {
      let j = jobs.create('stack')
      j.stack = obj
      return j
    },
  )
  obj.jobCreators.push(jc)

  jc = jobCreators.create(
    () => {
      if (obj.cargoes.length === 0) {
        return false
      }

      for (let i = 0; i < obj.cargoes.length; i++) {
        let ca = obj.cargoes[i]
        if (ca.data.type !== obj.holdsType) {
          // This doesn't belong here
          return true
        }
      }

      return false
    },
    () => {
      let j = jobs.create('unstack')
      j.stack = obj

      for (let i = 0; i < obj.cargoes.length; i++) {
        let ca = obj.cargoes[i]
        if (ca.data.type !== obj.holdsType) {
          // This doesn't belong here
          j.targetCargo = ca
          break
        }
      }

      return j
    },
  )
  obj.jobCreators.push(jc)
}

export function onUpdate(obj: IMachine) {
  ensure(obj)
  stacks.update(obj)
}
